import React from "react";
import { useNavigate } from "react-router-dom";
import LoanSteps from "./Loansteps";
import CallToAction from "./CallToAction";

const GeneralInsuranceInfo = () => {
    const navigate = useNavigate();

    return (
        <>
            <div className="other-pages-main-section general-insurance-fin">
                <h2 className="other-pages-title">General Insurance</h2>
                <p>
                    <span onClick={() => navigate("/")} style={{ cursor: "pointer" }}>Home</span> /
                    <span onClick={() => navigate("/general-insurance-mumbai-thane-palghar-maharashtra-delhi-india")} style={{ cursor: "pointer" }}>General Insurance</span>
                </p>
            </div>
            <div className="info-loan-card-smco">
                <h2 className="info-loan-title-smco">What is General Insurance?</h2>

                <p className="info-loan-description-smco">
                    General insurance provides financial protection against various risks and unforeseen events. It covers assets, liabilities, and potential losses from accidents, theft, natural disasters, and other contingencies. Unlike life insurance, general insurance focuses on non-life risks and helps individuals and businesses recover from financial setbacks.
                    <br /><br />
                    Common types of general insurance include motor insurance, health insurance, property insurance, travel insurance, and liability insurance. Each type addresses specific risks and offers tailored coverage options. Premiums are calculated based on the insured value, risk factors, and coverage extent.
                    <br /> <br />
                    General insurance is essential for comprehensive financial planning. It provides peace of mind by ensuring that unexpected events don't lead to significant financial burden. Whether for personal or business needs, choosing the right general insurance policy can safeguard your assets and future.
                    <br /><br />
                    When selecting general insurance, consider your specific needs, compare coverage options, and review policy terms carefully. Working with experienced insurers helps you find the best protection at competitive rates.
                    <br />
                </p>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Key Features</h3>
                    <ul className="info-feature-list-smco">
                        <li><strong>Comprehensive coverage:</strong> Protection against multiple risks under a single policy.</li>
                        <li><strong>Customizable options:</strong> Tailored coverage based on individual or business needs.</li>
                        <li><strong>Quick claims process:</strong> Efficient settlement for valid claims.</li>
                        <li><strong>Affordable premiums:</strong> Cost-effective protection with flexible payment options.</li>
                        <li><strong>Add-on benefits:</strong> Additional riders for enhanced coverage.</li>
                    </ul>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Types of General Insurance</h3>
                    <ul className="info-types-list-smco">
                        <li><strong>Motor Insurance:</strong> Covers vehicles against accidents, theft, and third-party liabilities.</li>
                        <li><strong>Health Insurance:</strong> Provides medical expense coverage and hospitalization benefits.</li>
                        <li><strong>Property Insurance:</strong> Protects buildings and contents against damage or loss.</li>
                        <li><strong>Travel Insurance:</strong> Covers trip cancellations, medical emergencies, and lost baggage.</li>
                        <li><strong>Liability Insurance:</strong> Protects against legal liabilities and third-party claims.</li>
                    </ul>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Benefits</h3>
                    <ul className="info-benefits-list-smco">
                        <li><strong>Financial security:</strong> Protection against unexpected financial losses.</li>
                        <li><strong>Peace of mind:</strong> Confidence in facing uncertainties.</li>
                        <li><strong>Tax benefits:</strong> Potential tax deductions on premiums paid.</li>
                        <li><strong>Business continuity:</strong> Ensures smooth operations despite setbacks.</li>
                    </ul>
                </div>
            </div>
            <LoanSteps />
            <CallToAction />
        </>
    );
};

export default GeneralInsuranceInfo;
